import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import useLoyaltyPurchasePointsOffers from 'loyalty/hooks/useLoyaltyPurchasePointsOffers'
import { LOYALTY_PURCHASE_POINTS_PAGE } from 'loyalty/constants/loyaltyRoutes'
import getIsLoyaltyPurchasePointsEnabled from 'loyalty/selectors/getIsLoyaltyPurchasePointsEnabled'
import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const CardPane = styled(Pane)`
  padding: ${rem(20)} ${rem(24)};
`

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  align-items: stretch;

  ${mediaQueryUp.tablet} {
    flex-direction: row;
    align-items: center;
    gap: ${rem(20)};
  }
`

const Body = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`

const Action = styled.div`
  flex: 0 0 auto;

  ${mediaQueryUp.tablet} {
    align-self: center;
  }
`

function LoyaltyAccountBuyPointsCard() {
  const intl = useIntl()
  const [tier] = useCurrentLoyaltyTier()
  const isEnabled = useAppSelector(getIsLoyaltyPurchasePointsEnabled)
  const { customerHasEligibleOffers } = useLoyaltyPurchasePointsOffers()
  if (!isEnabled || !customerHasEligibleOffers) return null

  const heading = intl.formatMessage({
    id: 'DrDe7rdw-EMV3JO5mwhX',
    defaultMessage: 'Top up your Société Points',
    description: 'Heading on the buy-points CTA card shown on the Société account benefits tab',
  })

  const subhead = intl.formatMessage({
    id: 'dsUfJQ8Gv9NuFVf85uuo',
    defaultMessage: 'Buy more points and start redeeming sooner – on stays, flights and more.',
    description: 'Body copy on the buy-points CTA card shown on the Société account benefits tab',
  })

  const promoLine = intl.formatMessage({
    id: 'Edg8K-lE8p_xGdOSj5FA',
    defaultMessage: '20% more points for a limited time only',
    description: 'Promo tagline on the buy-points CTA card shown on the Société account benefits tab',
  })

  const buttonLabel = intl.formatMessage({
    id: 'nczjt2-qo9jEkvnAXJnE',
    defaultMessage: 'Top up points',
    description: 'Button label on the top-up-points CTA card linking to the Société top-up points page',
  })

  return <CardPane>
    <Layout>
      <LoyaltyTierIcon tier={tier} size={48} />
      <Body>
        <Group direction="vertical" gap={4}>
          <Heading variant="heading5">{heading}</Heading>
          <BodyText variant="medium">{subhead}</BodyText>
          <BodyText variant="medium" weight="bold" colour="highlight-primary-dark">{promoLine}</BodyText>
        </Group>
      </Body>
      <Action>
        <Group direction="horizontal" horizontalAlign="end">
          <TextButton kind="secondary" to={`/${LOYALTY_PURCHASE_POINTS_PAGE}`} fit="mobile-full-width">
            {buttonLabel}
          </TextButton>
        </Group>
      </Action>
    </Layout>
  </CardPane>
}

export default LoyaltyAccountBuyPointsCard
